import React, { useEffect, useState } from 'react';
import { InputText } from 'primereact/inputtext';
import { RadioButton } from 'primereact/radiobutton';
import { useFormCreateCartao } from '../../controllers/Cartao/CreateCartaoController';
import LoadingScreen from '../../components/LoadingScreen';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import classNames from 'classnames';
import { useHistory } from 'react-router-dom';

const CartaoForm: React.FC = () => {
    const { getCartaoFormController, handleCartaoFormController } = useFormCreateCartao();
    const history = useHistory();

    const [registerFinished, setRegisterFinished] = useState(false);

    useEffect(() => {
        if (getCartaoFormController.cartaoResponse?.status === 200) {
            setRegisterFinished(true);
        }
        if (
            getCartaoFormController.cartaoEditedResponse?.status === 200 &&
            !getCartaoFormController.cartaoResponse
        ) {
            setRegisterFinished(false);
        }
    }, [getCartaoFormController.cartaoResponse, getCartaoFormController.cartaoEditedResponse]);

    const handleChangeCuringaSIM = (e: any) => {
        getCartaoFormController.formik.setFieldValue("CURINGA", 0)
    };

    const handleChangeCuringaNAO = (e: any) => {
        getCartaoFormController.formik.setFieldValue("CURINGA", 1)
    };

    const handleChangeStatusSIM = (e: any) => {
        getCartaoFormController.formik.setFieldValue("STATUS", 0)
    };

    const handleChangeStatusNAO = (e: any) => {
        getCartaoFormController.formik.setFieldValue("STATUS", 1)
    };

    return (
        <div style={{ height: '100%' }} className='p-grid p-align-center p-justify-center'>
            <Toast ref={getCartaoFormController.toast} />
            {getCartaoFormController.loading ? <LoadingScreen color='#0388e5' /> : <></>}
            <div className='p-col-12 p-md-8'>
                <div className='card p-fluid'>
                    <h5>Cartão</h5>
                    <div className='p-field'>
                        <label htmlFor='name'>Descricao</label>
                        <InputText
                            id='name'
                            type='text'
                            maxLength={150}
                            disabled={registerFinished}
                            value={getCartaoFormController.formik.values.DESCRICAO}
                            onChange={getCartaoFormController.formik.handleChange('DESCRICAO')}
                        />
                        <div
                            className={classNames('p-invalid popup-fade', {
                                'popup-form-active':
                                    getCartaoFormController.formik.touched.DESCRICAO &&
                                    getCartaoFormController.formik.errors.DESCRICAO,
                                'popup-form-inactive': !(
                                    getCartaoFormController.formik.touched.DESCRICAO &&
                                    getCartaoFormController.formik.errors.DESCRICAO
                                ),
                            })}>
                            {getCartaoFormController.formik.errors.DESCRICAO}
                        </div>
                    </div>
                    <label htmlFor='name'>Identificação (Número)</label>
                    <div className='p-field'>

                        <InputText
                            id='identificacaoCartao'
                            type='text'
                            style={{ width: '200px' }}
                            maxLength={20}
                            disabled={registerFinished}
                            value={getCartaoFormController.formik.values.IDENTIFICACAO}
                            onChange={getCartaoFormController.formik.handleChange('IDENTIFICACAO')}
                        />
                        <div
                            className={classNames('p-invalid popup-fade', {
                                'popup-form-active':
                                    getCartaoFormController.formik.touched.IDENTIFICACAO &&
                                    getCartaoFormController.formik.errors.IDENTIFICACAO,
                                'popup-form-inactive': !(
                                    getCartaoFormController.formik.touched.IDENTIFICACAO &&
                                    getCartaoFormController.formik.errors.IDENTIFICACAO
                                ),
                            })}>
                            {getCartaoFormController.formik.errors.IDENTIFICACAO}
                        </div>
                    </div>

                    <label htmlFor='name'>Curinga</label>
                    <div className='p-field p-mt-2'>
                        <div>
                            <RadioButton
                                inputId="simCuringa"
                                name="resposta"
                                value={getCartaoFormController.formik.values.CURINGA}
                                checked={getCartaoFormController.formik.values.CURINGA === 0}
                                onChange={handleChangeCuringaSIM}
                            />
                            <label htmlFor="simCuringa">Sim</label>
                        </div>
                        <div className=' p-mt-2'>
                            <RadioButton
                                inputId="naoCuringa"
                                name="resposta"
                                value={getCartaoFormController.formik.values.CURINGA}
                                checked={getCartaoFormController.formik.values.CURINGA === 1}
                                onChange={handleChangeCuringaNAO}
                            />
                            <label htmlFor="naoCuringa">Não</label>
                        </div>

                    </div>

                    <label htmlFor='name'>Ativo</label>
                    <div className='p-field p-mt-2'>
                        <div>
                            <RadioButton
                                inputId="simStatus"
                                name="resposta"
                                value={getCartaoFormController.formik.values.STATUS}
                                checked={getCartaoFormController.formik.values.STATUS === 0}
                                onChange={handleChangeStatusSIM}
                            />
                            <label htmlFor="simStatus">Sim</label>
                        </div>
                        <div className=' p-mt-2'>
                            <RadioButton
                                inputId="naoStatus"
                                name="resposta"
                                value={getCartaoFormController.formik.values.STATUS}
                                checked={getCartaoFormController.formik.values.STATUS === 1}
                                onChange={handleChangeStatusNAO}
                            />
                            <label htmlFor="naoStatus">Não</label>
                        </div>

                    </div>



                    <div className='p-fluid p-grid p-justify-between'>
                        {getCartaoFormController.cartaoResponse?.status === 200 && !registerFinished ? (
                            <div className='p-col-12 p-md-4'>
                                <Button
                                    type='button'
                                    label='Salvar Alterações'
                                    onClick={() => {
                                        getCartaoFormController.formik.handleSubmit();
                                    }}
                                />
                            </div>
                        ) : getCartaoFormController.cartaoResponse?.status === 200 && registerFinished ? (
                            <div className='p-col-12 p-md-6 p-fluid p-grid'>
                                <div className='p-col-12 p-md-5'>
                                    <Button
                                        type='button'
                                        label='Editar'
                                        onClick={() => {
                                            setRegisterFinished(false);
                                        }}
                                    />
                                </div>
                                <div className='p-col-12 p-md-5'>
                                    <Button
                                        icon='pi pi-plus'
                                        type='button'
                                        className='p-button-success'
                                        label='Cadastrar novo'
                                        onClick={() => {
                                            getCartaoFormController.formik.resetForm();
                                            setRegisterFinished(false);
                                            handleCartaoFormController.setCartaoResponse(null);
                                        }}
                                    />
                                </div>
                            </div>
                        ) : (
                            <div className='p-col-12 p-md-4'>
                                <Button
                                    type='button'
                                    label='Cadastrar'
                                    onClick={() => getCartaoFormController.formik.handleSubmit()}
                                />
                            </div>
                        )}

                        <div className='p-col-12 p-md-4'>
                            <Button
                                type='button'
                                className='p-button-secondary'
                                label='Voltar para listagem'
                                onClick={() => history.goBack()}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div >
    );
};

export default CartaoForm;
